import { Skeleton } from "@/components/ui/skeleton";

/**
 * Simple page-level loading component for React.lazy() Suspense fallback
 */
export const PageLoader = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <Skeleton className="h-12 w-12 rounded-full" />
        <Skeleton className="h-4 w-32" />
      </div>
    </div>
  );
};
